import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket } from '@fortawesome/free-solid-svg-icons';
import '../styles/SavedPage.css';

const SavedPage = () => {
  return (
    <div className="saved-page">
      <div className="coming-soon-container">
        <div className="coming-soon-content">
          <h1 className="coming-soon-title">
            Coming Soon!
          </h1>
          
          <div className="coming-soon-icon">
            <FontAwesomeIcon icon={faRocket} className="rocket-icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SavedPage;